import React, { createContext, useContext, useState } from 'react';

const PasswordProtectionFormContext = createContext();

export const PasswordProtectionFormProvider = ({ children }) => {
    const [passwordProtectionForm, setPasswordProtectionForm] = useState('');

    return (
        <PasswordProtectionFormContext.Provider value={{ passwordProtectionForm, setPasswordProtectionForm }}>
            {children}
        </PasswordProtectionFormContext.Provider>
    );
};

export const usePasswordProtectionForm = () => useContext(PasswordProtectionFormContext);
